export default __webpack_public_path__ + "static/media/pot6.a08ee4ec.svg";